import React, { createContext, useContext } from 'react';
var PortalCreateContext = /*#__PURE__*/createContext(undefined);
export var PortalCreateContextProvider = function PortalCreateContextProvider(_ref) {
  var KbSuggestionField = _ref.KbSuggestionField,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(PortalCreateContext.Provider, {
    value: {
      KbSuggestionField: KbSuggestionField
    }
  }, children);
};
export function usePortalCreateContext() {
  var _portalCreateContextD;
  var portalCreateContextData = useContext(PortalCreateContext);
  return {
    KbSuggestionField: (_portalCreateContextD = portalCreateContextData === null || portalCreateContextData === void 0 ? void 0 : portalCreateContextData.KbSuggestionField) !== null && _portalCreateContextD !== void 0 ? _portalCreateContextD : undefined
  };
}